import { Reducer } from 'redux';
import {
    ActionTypes,
    GET_LIVE_UPDATE_VALIDATIONS_REQUEST, 
    GET_LIVE_UPDATE_VALIDATIONS_SUCCESS, 
    GET_LIVE_UPDATE_VALIDATIONS_FAILURE,
    RESET_LIVE_UPDATE_VALIDATIONS_STATE
} from '../actions/liveUpdateValidations.actions';

export interface LiveUpdateValidation {
    validationType: 'INDIVIDUAL' | 'LEGAL_ENTITY';
    company: {
        id: number;
        name: string;
    };
    jobId: string;
    runDate: string;
    validationInfo: {
        firstName?: string;
        lastName?: string;
        name?: string;
    };
}

export interface Pagination {
    currentPage: number;
    totalPages: number;
    totalCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    nextPage: number | null;
    previousPage: number | null;
}

export interface State {
    validations: LiveUpdateValidation[];
    pagination: Pagination | null;
    loading: boolean;
    error: string | null;
}

const initialState: State = {
    validations: [],
    pagination: null,
    loading: false,
    error: null,
};

const reducer: Reducer<State, ActionTypes> = (state = initialState, action): State => {
    switch (action.type) {
        case GET_LIVE_UPDATE_VALIDATIONS_REQUEST:
            return { ...state, loading: true, validations: [], pagination: null, error: null };
        case GET_LIVE_UPDATE_VALIDATIONS_SUCCESS:
            return {
                ...state,
                validations: action.payload.validations,
                pagination: action.payload.pagination,
                loading: false,
                error: null,
            };
        case GET_LIVE_UPDATE_VALIDATIONS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case RESET_LIVE_UPDATE_VALIDATIONS_STATE:
            return { ...initialState }
        default:
            return state;
    }
};

export default reducer;
